import type { AttemptHistoryItem } from "@/types";

interface ProgressChartProps {
  attempts: AttemptHistoryItem[];
}

export default function ProgressChart({ attempts }: ProgressChartProps) {
  if (attempts.length === 0) {
    return (
      <div className="text-center py-8">
        <p className="text-sm text-gray-500">Complete exams to see your progress chart</p>
      </div>
    );
  }

  const completedAttempts = attempts
    .filter((a) => a.score !== null)
    .slice(0, 20)
    .reverse();

  if (completedAttempts.length === 0) {
    return (
      <div className="text-center py-8">
        <p className="text-sm text-gray-500">No completed exams yet</p>
      </div>
    );
  }

  const maxScore = Math.max(...completedAttempts.map((a) => a.total_questions));
  const chartHeight = 200;
  const barWidth = Math.min(40, (100 / completedAttempts.length));
  const passMarkY = maxScore > 0 ? ((1 - 43 / maxScore) * chartHeight) : 0;

  return (
    <div className="relative">
      <div className="flex items-end justify-between space-x-1" style={{ height: chartHeight }}>
        {completedAttempts.map((attempt, index) => {
          const score = attempt.score ?? 0;
          const height = maxScore > 0 ? (score / maxScore) * chartHeight : 0;
          const passed = attempt.passed;

          return (
            <div
              key={attempt.id}
              className="flex flex-col items-center flex-1"
              title={`Score: ${score}/${attempt.total_questions}`}
            >
              <span className="text-xs text-gray-500 mb-1 font-medium">{score}</span>
              <div
                className={`w-full max-w-[${barWidth}px] rounded-t-md transition-all ${
                  passed ? "bg-success-400 hover:bg-success-500" : "bg-danger-400 hover:bg-danger-500"
                }`}
                style={{ height: `${height}px`, minWidth: "12px" }}
              />
              <span className="text-xs text-gray-400 mt-1">
                {index + 1}
              </span>
            </div>
          );
        })}
      </div>

      <div
        className="absolute left-0 right-0 border-t-2 border-dashed border-primary-400 pointer-events-none"
        style={{ top: `${passMarkY + 20}px` }}
      >
        <span className="absolute -top-4 right-0 text-xs text-primary-600 font-medium bg-white px-1">
          Pass: 43
        </span>
      </div>

      <div className="mt-2 text-center text-xs text-gray-400">
        Recent exam attempts
      </div>
    </div>
  );
}
